import { create } from "zustand";
import type { AppConfiguration } from "@kappa-v2/contracts";

interface ConfigState {
  config: AppConfiguration | null;
  loading: boolean;
  error: string | null;
  setConfig: (config: AppConfiguration) => void;
  setError: (error: string) => void;
  setLoading: (loading: boolean) => void;
}

export const useConfigStore = create<ConfigState>((set) => ({
  config: null,
  loading: true,
  error: null,
  setConfig: (config) => set({ config, loading: false, error: null }),
  setError: (error) => set({ error, loading: false }),
  setLoading: (loading) => set({ loading })
}));
